import React, {useState} from "react";
import Sidebar from "../Components/sidebar";
import Navbar from "../Components/navbar"
import Top from "../Components/TopSection";
import InfoGerais from "../Components/InfoSection/index";
import { homeObj, homeObj2 } from "../Components/InfoSection/data";
import Formation from "../Components/Formation";
import Profissional from "../Components/Profissional";
import Footer from "../Components/Footer";

const Home = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen);
    }


    return (
        <>
        <Sidebar isOpen={isOpen} toggle={toggle}/>
        <Navbar toggle={toggle} />
        <Top/>
        <InfoGerais {...homeObj}/>
        <InfoGerais {...homeObj2}/>
        <Formation/>
        <Profissional/>
        <Footer/>
        
        
        </>

    )
}

export default Home; 